import ReactQuill from 'react-quill';

const Quill = ReactQuill.Quill;

var Inline = Quill.import('blots/inline');

class CustomStrongBlot extends Inline {
  static create(value) {
    let node = super.create(value);
    node.setAttribute('class', 'custom-strong-numbers');
    return node;
  }
}

CustomStrongBlot.blotName = 'customStrong';
CustomStrongBlot.tagName = 'b';

export default CustomStrongBlot;
